export default function About() {
  return (
    <section id="about" className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
              Why Choose The Auto Salon?
            </h2>
            <p className="text-base sm:text-lg text-gray-700 mb-6 sm:mb-8 leading-relaxed">
              At The Auto Salon, we don't just clean vehicles—we restore, protect, and enhance them with precision and care. Whether you drive a daily commuter, luxury vehicle, or weekend show car, we treat every vehicle with the same level of dedication and craftsmanship.
            </p>

            <div className="space-y-4 sm:space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#00D9FF] rounded-lg flex-shrink-0">
                  <i className="ri-medal-line text-white text-lg sm:text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">Professional-Grade Products</h3>
                  <p className="text-sm sm:text-base text-gray-700">
                    We use only the highest quality detailing products and proven techniques to deliver consistent, long-lasting results.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#00D9FF] rounded-lg flex-shrink-0">
                  <i className="ri-shield-star-line text-white text-lg sm:text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">Meticulous Attention to Detail</h3>
                  <p className="text-sm sm:text-base text-gray-700">
                    Every vehicle receives comprehensive care from top to bottom, ensuring no detail is overlooked.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#00D9FF] rounded-lg flex-shrink-0">
                  <i className="ri-customer-service-2-line text-white text-lg sm:text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">Customer-Focused Service</h3>
                  <p className="text-sm sm:text-base text-gray-700">
                    Honest communication, reliable results, and a commitment to your complete satisfaction.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="w-full h-64 sm:h-96 lg:h-full lg:min-h-[500px] rounded-3xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/a0d4f3e3ac0e43961d5f9d9c3e8e4af3.jpg"
                alt="Professional Detailing"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
